import { Button, Link } from "@heroui/react";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { getInstrumentAuditColumns } from "./columns";

import { EditCardWrapper } from "@/features/Edit/EditCardWrapper.tsx";
import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import { a7FIAInstrumentsEditForm } from "@/pages/a7/EditForms/a7FIAInstrumentsEditForm.tsx";

const table_name = "a7_fia_instruments";

export const A7FIAInstrumentsEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getInstrumentAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <EditCardWrapper
              client={"a7"}
              id={Number(id)}
              headerText={t(`${table_name}.title`, {
                ns: "tables",
                defaultValue: "Financial instrument",
              })}
              {...a7FIAInstrumentsEditForm}
              disable_translations_request={true}
            />
          </div>
          <div>
            <Button
              href={toWorkspacePath(
                `/admin/a7-fia/a7_fia_instrument_ts?instrument_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_fia_instrument_ts.title", {
                ns: "tables",
                defaultValue: "Time series",
              })}
            </Button>
          </div>
        </div>
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
